export default ".dropdown {\n  height: 50px;\n  font-size: 14px;\n}";